import { fetchServerData } from '@shared/utils/fetchServerData/fetchServerData';

import { PersonalAccountInfoType } from '../../';

export const getProfileInfo = async (cookie: string) => {
  return await fetchServerData<PersonalAccountInfoType>('v2/user/profile', { headers: { cookie } });
};
